import React from "react";
import { ServiceCard } from "./ServiceCard";
import { BookingEventWithPrice } from "../../../models/booking/BookingEventWithPrice";
import { formatPrice, getChargeLabel } from "../../../utils";

interface ServiceSectionProps {
  title: string;
  icon: string;
  iconColor: string;
  events: BookingEventWithPrice[];
  bookingDate: Date | null | undefined;
  sectionType: 'charge' | 'hold' | 'none';
  tax?: number;
  anyProviderFlags?: Record<number, boolean>;
}

export const ServiceSection: React.FC<ServiceSectionProps> = ({
  title,
  icon,
  iconColor,
  events,
  bookingDate,
  sectionType,
  tax,
  anyProviderFlags,
}) => {
  if (events.length === 0) return null;

  return (
    <div className="mb-2">
      <div className="d-flex align-items-center mb-3">
        <i className={`fa ${icon} me-2 ${iconColor}`}></i>
        <h5 className="mb-0">{title}</h5>
      </div>
      <div className="border rounded p-3" style={{ backgroundColor: '#ffffff' }}>
        {events.map((event, index) => (
          <div key={event.id || index}>
            <ServiceCard
              event={event}
              bookingDate={bookingDate}
              chargeAmount={event.priceDetails?.finalChargeAmount ?? 0}
              chargeLabel={getChargeLabel(event.priceDetails?.appliedChargeType)}
              sectionType={sectionType}
              isAnyProvider={anyProviderFlags?.[event.id] ?? false}
            />
          </div>
        ))}
        
        {/* Tax Row */}
        {tax && tax > 0 && (
          <div className="mt-3">
            <hr className="mb-3 mx-1" style={{ borderColor: '#dee2e6', opacity: 0.75 }} />
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="mb-0 text-muted small">Tax:</p>
                <p className="mb-0 fw-normal">{formatPrice(tax)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};